"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var F_PlainDate_1 = __importDefault(require("./F_PlainDate"));
var F_PlainDate_Add = /** @class */ (function () {
    /** @hidden */
    function F_PlainDate_Add(plainDate, dir) {
        if (dir === void 0) { dir = 1; }
        this.plainDate = plainDate;
        this.dir = dir;
        this.days = this.days.bind(this);
        this.weeks = this.weeks.bind(this);
        this.months = this.months.bind(this);
        this.years = this.years.bind(this);
    }
    F_PlainDate_Add.prototype.days = function (days) {
        return new F_PlainDate_1.default(this.plainDate.add({ days: days * this.dir }));
    };
    F_PlainDate_Add.prototype.weeks = function (weeks) {
        return new F_PlainDate_1.default(this.plainDate.add({ weeks: weeks * this.dir }));
    };
    F_PlainDate_Add.prototype.months = function (months) {
        return new F_PlainDate_1.default(this.plainDate.add({ months: months * this.dir }));
    };
    F_PlainDate_Add.prototype.years = function (years) {
        return new F_PlainDate_1.default(this.plainDate.add({ years: years * this.dir }));
    };
    return F_PlainDate_Add;
}());
exports.default = F_PlainDate_Add;
//# sourceMappingURL=F_PlainDate_Add.js.map